export const modalNames = {
  saveDraft: 'saveDraft',
  setDeskName: 'setDeskName',
  changeAcceptanceDate: 'changeAcceptanceDate',
  addCalendarIntervals: 'addCalendarIntervals',
  selectOwnerForRegistration: 'selectOwnerForRegistration',
  setupIntervalForRegistration: 'setupIntervalForRegistration',
  changeRoomStage: 'changeRoomStage',
  changeRoomStep: 'changeRoomStep',
  changeRoomAcceptanceStatus: 'changeRoomAcceptanceStatus',
  roomInfoDrawer: 'roomInfoDrawer',
  attachmentsForm: 'attachmentsForm',
  addTenant: 'addTenant',
};
